module.exports = __webpack_public_path__ + "img/Dai6-re.5d81c0a5.png";